<template>
<!-- eslint-disable max-len -->
<div class="bottom-bar" :style="rootStyle">
<div class="bottom-bar" :style="barStyle">
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <p v-if="showPlayer" class="caption player-caption">{{ playerName }}: {{ role && role.title || playerRole.title }}</p>
  </transition>

  <template v-if="!noBar">
    <div v-if="false" class="grad-footer">
      <img :src="resolveAssetPath('https://assets.redmeru.com/eai/blade_logos/BLADE-FullWordmark-dark.jpg', 'ui/customer')" class="logo">
      <span class="message" :style="{ color: $slots.default ? 'white' : 'transparent' }"><slot>?</slot></span>
    </div>
  </template>

  <slot name="choices"></slot>

  <template v-if="native && (to || next) && (from || back)">
    <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"> -->
      <button
        v-if="displayNext"
        class="btn navigate-button"
        :class="{ 'with-description': $slots.challengeDescription }"
        @click.prevent.stop="navigate"
        v-focus="!disableNextFocus"
        :style="buttonStyle"
        :disabled="disableNext"
      >
        <slot name="button">{{(game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next'}}</slot>
      </button>
    <!-- </transition> -->

    <!-- TODO: figure out why transition works on next button but not back button..? -->
    <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"> -->
    <button
      v-if="displayBack"
      class="btn back-button"
      @click.prevent.stop="navigateBack"
      :style="backButtonStyle"
      :disabled="disableBack"
    >
      <slot name="back">Back</slot>
    </button>
    <!-- </transition> -->
  </template>
  <template v-else>
    <div class="navigate-button-wrapper">
      <button
        v-if="displayNext"
        class="btn navigate-button"
        :class="{ starfighter, 'with-description': $slots.challengeDescription }"
        @click.prevent.stop="navigate"
        v-focus="!disableNextFocus"
        :style="buttonStyle"
        :disabled="disableNext"
      >
        <slot name="button">{{(game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next'}}</slot>
      </button>
    </div>

    <div class="navigate-button-wrapper" :class="{ decision: decisionStyle }">
      <button
        v-if="displayBack"
        class="btn back-button"
        :class="{ starfighter }"
        @click.prevent.stop="navigateBack"
        :style="backButtonStyle"
        :disabled="disableBack"
        v-b-tooltip.hover.bottomright :title="$slots.back"
      >
        &nbsp;
        <!-- <slot name="back">Back</slot> -->
      </button>
    </div>
  </template>

  <!-- TODO: -->
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <button v-if="true" class="btn chat-button" @click.prevent.stop="toggleChatVisible">Chat</button>
  </transition> -->
</div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    to: { type: String },
    from: { type: String },
    replace: { type: Boolean },
    next: { type: Function },
    back: { type: Function },
    noBar: { type: Boolean },
    noFocus: { type: Boolean },
    tabindex: { type: [Number, String] },
    showPlayer: { type: Boolean },
    role: { type: Object },
    choiceHeight: { type: String, default: '0' },
    disableNextFocus: { type: Boolean, default: false },
    disableNext: { type: Boolean, default: false },
    disableBack: { type: Boolean, default: false },
    decisionStyle: { type: Boolean, default: false },
    narrativeStyle: { type: Boolean, default: false },
  },
  data() {
    return {
      showChat: false,
      hideButton: false,
      displayNext: false,
      displayBack: false,
      nextOpacity: 1,
      backOpacity: 1,
      // if narrative overrides colors, this is for restoring colors when leaving this narrative
      oldNextButtonColor: '',
      oldNextButtonColorLightened: '',
      oldNextButtonTextColor: '',
    };
  },
  computed: {
    ...mapGetters([
      'multiplayer',
      'me',
      'playerRole',
      'proxyAvatar',
      'playerDecision',
      'narrative',
      'game',
      'starfighter',
      'native'
    ]),
    shouldDisplayNext() {
      return (this.to || this.next) && !(this.hideButton);
    },
    shouldDisplayBack() {
      return (this.from || this.back) && !(this.hideButton);
    },
    playerName() {
      return (this.proxyAvatar && this.proxyAvatar.title) || this.me.firstName || this.me.email;
    },
    height() {
      return `${this.choiceHeight && this.choiceHeight !== '0' ? `calc(${this.choiceHeight} + 50px)` : '140px'}`;
    },
    rootStyle() {
      if (this.native) {
        return {
          height: this.height,
          perspective: '1px', // needed for sliced background
        };
      }
      return '';
    },
    barStyle() {
      if (this.native) {
        const borderWidth =
          (this.playerDecision != null && ['roleAllocation', 'projectAllocation'].includes(this.playerDecision.type))
            ? '60px'
            : '140px';
        return {
          height: this.height,
          border: `${borderWidth} solid rgba(0,0,0,0)`,
          'border-image': 'url("/static/ui/customer/B2_LowerBand.png") 140 0 0 0 fill stretch',
          'border-right': 'none',
          'border-left': 'none',
          'border-bottom': 'none',
          transform: 'translateZ(0)', // needed for sliced background
          // 'background-image': 'url("/static/ui/customer/B2_LowerBand.png")',
          // 'background-size': '100% 100%'
        };
      }
      return '';
    },
    buttonContainerStyle() {
      const useLeft = (!(this.game.insetNextButtonPositionXFromRight) && this.game.insetNextButtonPositionX);
      return {
        bottom:
          (this.game.nextButtonPositionY)
            ? this.game.nextButtonPositionY
            : undefined,
        left:
          useLeft
            ? this.game.nextButtonPositionX
            : undefined,
        right:
          useLeft
            ? 'unset'
            : ((this.game.nextButtonPositionXFromRight && this.game.nextButtonPositionX)
              ? this.game.nextButtonPositionX
              : undefined),
      };
    },
    nextButtonWidth() {
      return this.game.nextButtonWidth ? this.game.nextButtonWidth : '279px';
    },
    buttonStyle() {
      if (this.native) {
        return {
          position: 'absolute',
          bottom: (
            (this.narrativeStyle && this.narrative.buttonYOffset)
              ? `calc(35px + ${this.narrative.buttonYOffset})`
              : '35px'
          ),
          right: (
            (this.narrativeStyle && this.narrative.buttonXOffset)
              ? `calc(10px - ${this.narrative.buttonXOffset})`
              : '10px'
          ),
          height: 'calc(50% + 70px)',
          'max-height': '80px',
          'line-height': '40px',
          opacity: this.nextOpacity
        };
      }
      const buttonWidth = this.nextButtonWidth;
      const buttonHeight =
        this.game.nextButtonHeight
          ? this.game.nextButtonHeight
          : undefined;
      return {
        width: buttonWidth,
        height: buttonHeight,
        'margin-right': this.game.nextButtonPositionX ? 'unset' : '16px',
        'padding-right': '42px',
        bottom: (
          (this.narrativeStyle && this.narrative.buttonYOffset)
            ? `calc(110px + ${this.narrative.buttonYOffset})`
            : undefined
        ),
        right: (
          (this.narrativeStyle && this.narrative.buttonXOffset)
            ? `calc(0px - ${this.narrative.buttonXOffset})`
            : undefined
        ),
        opacity: this.nextOpacity
      };
    },
    backButtonStyle() {
      if (this.native) {
        return {
          position: 'absolute',
          bottom: '35px',
          left: '10px',
          height: 'calc(50% + 70px)',
          'max-height': '80px',
          'line-height': '40px',
          opacity: this.backOpacity
        };
      }
      const buttonWidth =
        this.game.nextButtonWidth
          ? `calc(84 * ${this.game.nextButtonWidth} / 279)`
          : '84px';
      const buttonHeight =
        this.game.nextButtonHeight
          ? this.game.nextButtonHeight
          : undefined;
      return {
        left: this.decisionStyle ? undefined : 'unset',
        bottom: (
          (this.narrativeStyle && this.narrative.buttonYOffset)
            ? `calc(110px + ${this.narrative.buttonYOffset})`
            : undefined
        ),
        right: (
          (this.narrativeStyle && this.narrative.buttonXOffset)
            ? `calc(0px - ${this.narrative.buttonXOffset})`
            : (this.decisionStyle ? undefined : '0')
        ),
        width: buttonWidth,
        height: buttonHeight,
        'margin-left': '8px',
        'margin-right':
          this.game.nextButtonPositionX
            ? `calc(${this.nextButtonWidth} + 4px)`
            : `calc(${this.nextButtonWidth} + 20px)`,
        opacity: this.backOpacity
      };
    }
  },
  methods: {
    ...mapActions([
      'playSound',
      'toggleChatVisible'
    ]),
    async playClick() {
      await Vue.nextTick();
      this.playSound({
        sound:
          this.game.nextButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
        soundIsUnstoppable: true,
      });
    },
    async playBackClick() {
      await Vue.nextTick();
      this.playSound({
        sound:
          this.game.backButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
        soundIsUnstoppable: true,
      });
    },
    async navigate() {
      await this.playClick();
      // window.dispatchEvent(new Event('click'));
      this.hideButton = true;
      await new Promise(resolve => setTimeout(resolve, 1));
      if (this.next) {
        this.next();
      } else if (this.to) {
        if (this.replace) this.$router.replace(this.to);
        else this.$router.push(this.to);
      }
      await new Promise(resolve => setTimeout(resolve, 999));
      this.hideButton = false;
    },
    async navigateBack() {
      await this.playBackClick();
      // window.dispatchEvent(new Event('click'));
      this.hideButton = true;
      await new Promise(resolve => setTimeout(resolve, 1));
      if (this.back) {
        this.back();
      } else if (this.from) {
        if (this.replace) this.$router.replace(this.from);
        else this.$router.push(this.from);
      }
      await new Promise(resolve => setTimeout(resolve, 999));
      this.hideButton = false;
    },
    applyButtonStyleVariableChanges() {
      if (this.narrativeStyle) {
        if (this.narrative.buttonColor) {
          const before = document.documentElement.style.getPropertyValue('--buttonColor');
          if (before !== this.narrative.buttonColor) {
            this.oldNextButtonColor = before;
            document.documentElement.style.setProperty('--buttonColor', this.narrative.buttonColor);
          }
        }
        if (this.narrative.buttonColorLightened) {
          const before = document.documentElement.style.getPropertyValue('--buttonColorLightened');
          if (before !== this.narrative.buttonColorLightened) {
            this.oldNextButtonColorLightened = before;
            document.documentElement.style.setProperty('--buttonColorLightened', this.narrative.buttonColorLightened);
          }
        }
        if (this.narrative.buttonTextColor) {
          const before = document.documentElement.style.getPropertyValue('--buttonTextColor');
          if (before !== this.narrative.buttonTextColor) {
            this.oldNextButtonTextColor = before;
            document.documentElement.style.setProperty('--buttonTextColor', this.narrative.buttonTextColor);
          }
        }
      }
    },
    undoButtonStyleVariableChanges() {
      if (this.oldNextButtonColor) {
        const current = document.documentElement.style.getPropertyValue('--buttonColor');
        if (current !== this.oldNextButtonColor) {
          document.documentElement.style.setProperty('--buttonColor', this.oldNextButtonColor);
          this.oldNextButtonColor = '';
        }
      }
      if (this.oldNextButtonColorLightened) {
        const current = document.documentElement.style.getPropertyValue('--buttonColorLightened');
        if (current !== this.oldNextButtonColorLightened) {
          document.documentElement.style.setProperty('--buttonColorLightened', this.oldNextButtonColorLightened);
          this.oldNextButtonColorLightened = '';
        }
      }
      if (this.oldNextButtonTextColor) {
        const current = document.documentElement.style.getPropertyValue('--buttonTextColor');
        if (current !== this.oldNextButtonTextColor) {
          document.documentElement.style.setProperty('--buttonTextColor', this.oldNextButtonTextColor);
          this.oldNextButtonTextColor = '';
        }
      }
    },
    async handleNextVisibilityChange() {
      if (this.shouldDisplayNext) {
        this.nextOpacity = 0;
        this.displayNext = this.shouldDisplayNext;
        await new Promise(resolve => setTimeout(resolve, 1));
        if (this.shouldDisplayNext) {
          // undo
          this.applyButtonStyleVariableChanges();
          this.nextOpacity = 1;
          this.displayNext = this.shouldDisplayNext;
        }
      } else {
        this.nextOpacity = 0;
        await new Promise(resolve => setTimeout(resolve, 501));
        this.displayNext = this.shouldDisplayNext;
        // could have changed again while waiting
        if (this.shouldDisplayNext) {
          // undo
          this.applyButtonStyleVariableChanges();
          this.nextOpacity = 1;
        } else {
          // finish button hide
          this.displayNext = this.shouldDisplayNext;
          this.undoButtonStyleVariableChanges();
        }
      }
    },
    async handleBackVisibilityChange() {
      if (this.shouldDisplayBack) {
        this.backOpacity = 0;
        this.displayBack = this.shouldDisplayBack;
        await new Promise(resolve => setTimeout(resolve, 1));
        // could have changed again while waiting
        if (this.shouldDisplayBack) {
          // undo
          this.backOpacity = 1;
          this.displayBack = this.shouldDisplayBack;
        }
      } else {
        this.backOpacity = 0;
        await new Promise(resolve => setTimeout(resolve, 501));
        // could have changed again while waiting
        if (this.shouldDisplayBack) {
          // undo
          this.backOpacity = 1;
        } else {
          // finish button hide
          this.displayBack = this.shouldDisplayBack;
        }
      }
    },
  },
  watch: {
    async shouldDisplayNext() {
      await this.handleNextVisibilityChange();
    },
    async shouldDisplayBack() {
      await this.handleBackVisibilityChange();
    },
  },
  async mounted() {
    await this.handleNextVisibilityChange();
    await this.handleBackVisibilityChange();
  }
};
</script>

<style lang="scss" scoped>
.bottom-bar {
  position: absolute;
  background-color: transparent;
  width: 1600px;
  height: 190px;
  bottom: 0;
  left: 0;
  transition: height 0.15s ease-in-out;
  pointer-events: none;
  z-index: 100 !important;
}
.bottom-bar button {
  pointer-events: auto;
}
.bottom-bar .btn {
  pointer-events: auto;
}
.bottom-bar button.navigate-button {
  position: absolute;
  bottom: 110px;
  right: 0;
  width: 350px;
  font-size: 40px;
  line-height: 78px;
  margin-right: 45px;
  z-index: 100 !important;
  transition: opacity 0.5s ease-in-out;
}
.bottom-bar button.navigate-button.starfighter {
  animation: none;
  mask: url('../../../assets/ui/mask2_next.png') center/contain;
  mask-repeat: no-repeat;
}
@keyframes focus-anim {
  0% {
    filter: none;
  }

  50% {
    // filter: drop-shadow(0px 0px 8px var(--primaryBorderColor));
    filter:
      drop-shadow(0px 0px 5px var(--primaryBorderColor))
      drop-shadow(0px 0px 6px var(--primaryBorderColor));
    // filter:
    //   drop-shadow(6px 6px 2px var(--primaryBorderColor))
    //   drop-shadow(-6px 6px 2px var(--primaryBorderColor))
    //   drop-shadow(6px -6px 2px var(--primaryBorderColor))
    //   drop-shadow(-6px -6px 2px var(--primaryBorderColor));
  }

  100% {
    // filter: none;
    // filter: drop-shadow(0px 0px 16px transparent);
    filter:
      drop-shadow(0px 0px 10px transparent)
      drop-shadow(0px 0px 12px transparent);
    // filter:
    //   drop-shadow(0px 0px 16px transparent)
    //   drop-shadow(0px 0px 16px transparent)
    //   drop-shadow(0px 0px 16px transparent)
    //   drop-shadow(0px 0px 16px transparent);
    // filter:
    //   drop-shadow(6px 6px 0px transparent)
    //   drop-shadow(-6px 6px 0px transparent)
    //   drop-shadow(6px -6px 0px transparent)
    //   drop-shadow(-6px -6px 0px transparent);
  }
}
.navigate-button-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
}
.navigate-button-wrapper.decision {
  right: unset;
  left: 0;
}
.navigate-button-wrapper:focus-within {
  animation: focus-anim 2s infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);
  animation-delay: 0.25s;
}
.bottom-bar button.back-button {
  position: absolute;
  bottom: 110px;
  left: 0;
  width: 350px;
  font-size: 40px;
  line-height: 78px;
  margin-left: 45px;
  z-index: 100 !important;
  transition: opacity 0.5s ease-in-out;
}
.bottom-bar button.back-button.starfighter {
  animation: none;
  mask: url('../../../assets/ui/mask2_back.png') center/contain;
  mask-repeat: no-repeat;
}
.bottom-bar button.chat-button {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 24px;
  line-height: 24px;
  margin: 0;
  padding: 10px 15px;
}
.frame-edge {
  @include game-frame-edge();
  position: absolute;
  bottom: 50px;
}
.grad-footer {
  position: absolute;
  bottom: 0;
  height: 50px;
  @include game-footer();
}
.logo {
  height: 51px;
  margin: -8px 15px 0px 5px;
}
.message {
  display: inline-block;
  height: 30px;
  width: 1263px;
  background-color: black;
  margin: 10px 0;
  font-size: 22px;
  line-height: 29px;
  padding-left: 5px;
  color: white;
  visibility: hidden;
}
.caption {
  position: absolute;
  bottom: 5px;
  background-color: var(--primaryColor);
  color: white;
  padding: 5px 20px;
  font-size: 22px;
  min-width: 300px;
  max-width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/BottomBar.vue